import axiosInstance from "../../../Utils/axiosInstance";
import {
  GroupBreakdownResponse,
  ReconRunPayload,
  ReconRunResponse,
  SelectOption,
} from "../../../Types/Reconautomation.types";
import { fetchReconPhysicalCodes } from "../ContractMap/contractmap.api";

const BASE_URL = "/paper-app/recon-automation-bilat-grpd/";
// NOTE: assumed endpoint — adjust the path once the backend confirms it.
// Expected to return the underlying (Major/Minor) trades that were rolled
// up into this group_id on both the ACERS and BGM sides.
const GROUP_BREAKDOWN_URL = "/paper-app/reconciliation/group";

const toBackendDate = (date: string): string => {
  if (!date) return date;
  const [y, m, d] = date.split("-");
  return `${d}-${m}-${y}`;
};

export const fetchContractOptions = async (): Promise<SelectOption[]> => {
  const data = await fetchReconPhysicalCodes();
  return data.map((item) => ({ label: item.physical_code, value: item.id }));
};

export const runReconciliation = async (
  payload: ReconRunPayload
): Promise<ReconRunResponse> => {
  const formData = new FormData();
  formData.append("source", payload.source);
  formData.append("start_date", toBackendDate(payload.start_date));
  formData.append("end_date", toBackendDate(payload.end_date));
  formData.append("file", payload.file);
  if (payload.contract) formData.append("contract", payload.contract);
  if (payload.buy_sell) formData.append("buy_sell", payload.buy_sell);
  const response = await axiosInstance.post<ReconRunResponse>(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const fetchGroupBreakdown = async (
  groupId: string
): Promise<GroupBreakdownResponse> => {
  const response = await axiosInstance.get<GroupBreakdownResponse>(
    `${GROUP_BREAKDOWN_URL}/${groupId}`
  );
  return response.data;
};

export const fetchGroupBreakdownsBatch = (groupIds: string[]) =>
  Promise.all(groupIds.map(id => fetchGroupBreakdown(id)));

export { fetchBrokerOptions } from "../../Trading/PaperTrading/FecthApis";